var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManSearching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.156 124.509L227.099 129.676L235.509 124.899L232.565 119.73L224.156 124.509Z",
    fill: "#BE906B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.775 126.267C231.229 126.116 230.908 125.555 231.059 125.011L232.632 119.302C232.784 118.76 233.346 118.439 233.889 118.587L236.853 119.402C237.393 119.554 237.714 120.113 237.565 120.656L235.992 126.367C235.842 126.912 235.28 127.229 234.732 127.08L231.775 126.267Z",
    fill: "#BE906B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.622 128.06C235.622 128.06 239.277 114.778 239.296 114.707L238.047 114.365L238.22 113.082C237.957 113.045 237.074 113.019 236.756 114.171L233.122 127.373L235.622 128.06Z",
    fill: "#0046FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.622 128.06C235.622 128.06 239.277 114.778 239.296 114.707L238.047 114.365L238.22 113.082C237.957 113.045 237.074 113.019 236.756 114.171L233.122 127.373L235.622 128.06Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.126 121.543C236.595 121.399 236.047 121.709 235.901 122.24C235.756 122.769 236.066 123.317 236.596 123.463L238.722 124.049C239.255 124.195 239.802 123.887 239.951 123.355H239.95C240.096 122.824 239.784 122.274 239.252 122.129L237.126 121.543Z",
    fill: "#BE906B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.655 119.623C237.124 119.478 236.576 119.788 236.43 120.318C236.285 120.849 236.595 121.396 237.126 121.543L239.251 122.128C239.784 122.274 240.332 121.966 240.48 121.434H240.478C240.625 120.904 240.312 120.354 239.781 120.209L237.655 119.623Z",
    fill: "#BE906B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.37 124.158C235.226 124.69 235.538 125.235 236.066 125.382L237.65 125.818C238.181 125.963 238.728 125.652 238.877 125.124C239.023 124.594 238.71 124.045 238.18 123.9L236.596 123.463C236.065 123.317 235.517 123.627 235.37 124.158Z",
    fill: "#BE906B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.066 125.382C235.537 125.235 234.987 125.546 234.841 126.078C234.697 126.607 235.005 127.157 235.535 127.302L236.341 127.523C236.871 127.668 237.418 127.359 237.567 126.828C237.709 126.298 237.4 125.748 236.869 125.604L236.066 125.382Z",
    fill: "#BE906B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.74 120.043C233.015 120.521 233.621 120.687 234.098 120.417L237.002 118.77C237.48 118.498 237.648 117.889 237.378 117.411C237.105 116.933 236.496 116.767 236.017 117.038L233.115 118.685C232.635 118.956 232.467 119.563 232.74 120.043Z",
    fill: "#BE906B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.491 261.537C171.005 262.521 173.696 263.148 175.662 262.854C177.277 262.617 179.427 264.362 176.648 265.29C173.205 266.439 169.671 266.024 168.592 264.656C168.593 265.202 168.596 265.828 168.596 265.828L164.29 265.829L164.738 261.537H170.491Z",
    fill: "#002C52"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.675 261.524C133.207 262.498 135.911 263.067 137.871 262.732C139.483 262.459 141.67 264.159 138.906 265.146C135.49 266.37 131.951 266.029 130.842 264.684C130.854 265.233 130.867 265.856 130.867 265.856L126.568 265.95L126.923 261.648L132.675 261.524Z",
    fill: "#002C52"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.964 90.4731C194.84 117.866 194.299 149.024 194.299 149.024C194.299 149.024 215.488 138.629 231.726 128.982L227.912 120.379C216.47 124.926 206.853 127.94 206.853 127.94C206.853 127.94 209.357 110.243 212.263 92.428C207.898 91.9927 198.799 90.7914 195.964 90.4731Z",
    fill: "#0046FE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.231 163.742C172.218 197.822 173.575 231.446 170.588 260.25C169.07 260.25 170.588 260.218 164.673 260.229C164.225 229.103 153.099 194.012 144.211 163.682C138.913 145.585 170.684 144.957 171.231 163.742Z",
    fill: "#002C52"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.231 163.742C172.218 197.822 173.575 231.446 170.588 260.25C169.07 260.25 170.588 260.218 164.673 260.229C164.225 229.103 153.099 194.012 144.211 163.682C138.913 145.585 170.684 144.957 171.231 163.742Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.601 164.301C142.478 202.273 135.138 231.213 132.635 260.06C131.119 260.089 132.635 260.03 126.723 260.141C125.753 229.024 125.21 199.758 120.584 164.119C118.16 145.418 150.115 145.679 147.601 164.301Z",
    fill: "#002C52"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.601 164.301C142.478 202.273 135.138 231.213 132.635 260.06C131.119 260.089 132.635 260.03 126.723 260.141C125.753 229.024 125.21 199.758 120.584 164.119C118.16 145.418 150.115 145.679 147.601 164.301Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.263 92.4281C204.075 103.437 175.373 137.942 173.855 168.844C160.394 166.016 130.103 162.073 118.191 162.018C120.511 106.346 170.479 57.9147 170.479 57.9147L212.263 92.4281Z",
    fill: "#0046FE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.477 86.9513C199.83 84.4415 202.801 86.7817 200.904 89.1952C195.445 96.1305 187.673 121.481 190.97 157.538C188.262 160.452 184.107 164.921 184.107 164.921C184.107 164.921 178.682 159.84 176.912 157.863C178.923 117.176 189.47 95.4891 197.477 86.9513Z",
    fill: "#FF5C35"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.171 82.361L204.075 85.4683L201.783 89.911L196.833 86.3427L200.171 82.361Z",
    fill: "#FF5C35"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.837 74.8293C222.065 71.6183 221.557 68.0074 218.53 64.9891C215.096 61.5598 212.731 61.3622 208.012 64.5293C205.438 66.2598 193.548 71.9866 190.354 74.2305L206.385 87.5135C208.08 85.9135 210.322 84.1708 212.391 82.5659C213.338 82.433 214.156 81.8854 214.103 81.1598C214.766 81.2513 215.333 81.1671 215.615 80.4403C215.806 79.9476 216.717 79.0391 216.717 79.0391L218.368 80.6878C218.368 80.6878 219.61 78.0439 220.837 74.8293Z",
    fill: "#BE906B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.799 74.8049C218.548 75.2695 217.971 75.4476 217.504 75.2C217.039 74.9537 216.863 74.3756 217.111 73.9073C217.359 73.4439 217.937 73.2646 218.404 73.5122C218.868 73.7622 219.047 74.3403 218.799 74.8049Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.239 73.25C216.99 73.7146 216.411 73.8902 215.946 73.6427C215.48 73.3988 215.303 72.8171 215.552 72.3537C215.8 71.8854 216.377 71.7085 216.844 71.9598C217.311 72.2049 217.485 72.7817 217.239 73.25Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.785 61.1695C215.162 59.989 217.506 60.4975 218.387 62.1158C219.269 63.7305 220.659 64.5451 221.207 63.828C221.334 65.7683 219.266 67.0866 217.581 66.6488C215.892 66.211 213.179 63.4683 212.731 62.9256C212.275 63.8256 208.698 65.2878 208.012 64.5292C208.134 62.2231 211.814 59.3097 213.785 61.1695Z",
    fill: "#59443B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.262 56.7293C124.427 73.8512 103.989 97.7561 91.9299 139.955L98.092 141.979C114.786 106.648 145.859 82.5439 171.092 75.6195C181.122 72.8695 172.938 51.8976 162.262 56.7293Z",
    fill: "#0046FE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2861 142.051C96.7464 142.321 96.5327 142.977 96.8038 143.515L98.3986 146.668C98.6697 147.206 99.3255 147.418 99.8604 147.15L99.8653 147.148C100.4 146.878 100.616 146.224 100.344 145.687L98.7503 142.533C98.4792 141.995 97.8222 141.781 97.2861 142.051Z",
    fill: "#BE906B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5171 140.667C90.7113 140.08 91.3426 139.762 91.93 139.955L98.0921 141.979C98.6771 142.176 98.9958 142.805 98.8065 143.39L97.7538 146.579C97.5585 147.162 96.9283 147.482 96.3421 147.289L90.1788 145.263C89.5914 145.071 89.2739 144.439 89.4669 143.852L90.5171 140.667Z",
    fill: "#BE906B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.6814 145.898C95.8707 145.327 95.5593 144.708 94.9865 144.524C94.415 144.335 93.7995 144.645 93.609 145.216L92.9166 147.322C92.7273 147.894 93.0363 148.51 93.6102 148.699V148.698C94.183 148.887 94.8009 148.576 94.989 148.005L95.6814 145.898Z",
    fill: "#BE906B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.7538 146.579C97.9406 146.009 97.6316 145.393 97.0589 145.204C96.4886 145.016 95.8707 145.324 95.6814 145.898L94.989 148.005C94.8009 148.576 95.1086 149.189 95.6814 149.379C96.2554 149.568 96.872 149.255 97.0589 148.685L97.7538 146.579Z",
    fill: "#BE906B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9154 143.841C92.3415 143.652 91.7272 143.963 91.5392 144.534L90.8443 146.643C90.6575 147.212 90.9677 147.829 91.5392 148.017C92.1107 148.206 92.7273 147.894 92.9154 147.323L93.609 145.216C93.7983 144.645 93.4881 144.03 92.9154 143.841Z",
    fill: "#BE906B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.5392 144.534C91.7272 143.963 91.4171 143.348 90.8444 143.161C90.2729 142.973 89.655 143.279 89.4669 143.852L88.7721 145.961C88.584 146.532 88.8954 147.146 89.4669 147.337C90.0384 147.522 90.6575 147.212 90.8444 146.643L91.5392 144.534Z",
    fill: "#BE906B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.752 103.739C254.524 111.831 246.151 116.588 238.047 114.363C229.943 112.14 225.181 103.777 227.407 95.6842C229.634 87.5915 238.009 82.8354 246.113 85.0586C254.216 87.283 258.979 95.6464 256.752 103.739Z",
    fill: "#0046FE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.752 103.739C254.524 111.831 246.151 116.588 238.047 114.363C229.943 112.14 225.181 103.777 227.407 95.6842C229.634 87.5915 238.009 82.8354 246.113 85.0586C254.216 87.283 258.979 95.6464 256.752 103.739Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.071 85.1585C243.373 85.1585 244.673 85.3354 245.941 85.6829C249.693 86.7122 252.818 89.1402 254.743 92.5183C256.666 95.8963 257.159 99.8195 256.128 103.567C254.394 109.865 248.621 114.263 242.088 114.263C240.787 114.263 239.486 114.088 238.219 113.74C230.473 111.613 225.904 103.591 228.032 95.8561C229.765 89.5573 235.539 85.1585 242.071 85.1585ZM242.088 115.559C249.203 115.557 255.489 110.768 257.377 103.91C258.501 99.8293 257.965 95.5561 255.869 91.878C253.775 88.2 250.37 85.5561 246.284 84.4354C244.905 84.0561 243.489 83.8646 242.071 83.8646C234.957 83.8646 228.67 88.6549 226.783 95.5122C224.464 103.937 229.44 112.673 237.876 114.988C239.254 115.366 240.671 115.559 242.088 115.559Z",
    fill: "#0046FE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.071 85.1585C243.373 85.1585 244.673 85.3354 245.941 85.6829C249.693 86.7122 252.818 89.1402 254.743 92.5183C256.666 95.8963 257.159 99.8195 256.128 103.567C254.394 109.865 248.621 114.263 242.088 114.263C240.787 114.263 239.486 114.088 238.219 113.74C230.473 111.613 225.904 103.591 228.032 95.8561C229.765 89.5573 235.539 85.1585 242.071 85.1585ZM242.088 115.559C249.203 115.557 255.489 110.768 257.377 103.91C258.501 99.8293 257.965 95.5561 255.869 91.878C253.775 88.2 250.37 85.5561 246.284 84.4354C244.905 84.0561 243.489 83.8646 242.071 83.8646C234.957 83.8646 228.67 88.6549 226.783 95.5122C224.464 103.937 229.44 112.673 237.876 114.988C239.254 115.366 240.671 115.559 242.088 115.559Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.451 95.9182C252.535 95.9182 252.622 95.9012 252.706 95.8658C253.035 95.7243 253.187 95.3438 253.046 95.0158C251.933 92.4292 249.94 90.3146 247.433 89.0609C247.113 88.9012 246.724 89.0304 246.564 89.3499C246.402 89.6694 246.532 90.0585 246.853 90.2182C249.087 91.3353 250.862 93.2207 251.855 95.5268C251.96 95.7719 252.199 95.9182 252.451 95.9182Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M191.259 266H112.741C112.332 266 112 266.224 112 266.5C112 266.776 112.332 267 112.741 267H191.259C191.668 267 192 266.776 192 266.5C192 266.224 191.668 266 191.259 266Z",
    fill: "black",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManSearching);
export default __webpack_public_path__ + "static/media/manSearching.09b16d60e352b54de1530df1888b2216.svg";
export { ForwardRef as ReactComponent };